import { all } from 'redux-saga/effects'

import { dataSaga } from './data/saga'

export function* dashboardSaga() {
  yield all([dataSaga()])
}
